import React from 'react';
import { Recipe } from '../../../api/Recipe';
import { Button, ButtonGroup, Flex } from '../../../components/ui';

interface EditRecipeActionBarProps {
  recipe: Recipe;
  isRecipeFavorite: boolean;
  favoritePendingIds: string[];
  onFavoriteToggle: () => void;
  onShare: () => void;
  onOpenFullScreen: () => void;
}

const EditRecipeActionBar: React.FC<EditRecipeActionBarProps> = ({
  recipe,
  isRecipeFavorite,
  favoritePendingIds,
  onFavoriteToggle,
  onShare,
  onOpenFullScreen,
}) => (
  <Flex justify="center" align="center" marginBottom={3} className="no-print">
    <ButtonGroup>
      <Button
        variant={isRecipeFavorite ? 'danger' : 'primary'}
        outline={!isRecipeFavorite}
        marginStart={2}
        onClick={onFavoriteToggle}
        disabled={favoritePendingIds.includes(recipe.id)}
        title={isRecipeFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
      >
        {isRecipeFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
      </Button>
      <Button variant="secondary" outline marginStart={2} onClick={onShare} title="Partager">
        Partager
      </Button>
      <Button
        variant="secondary"
        outline
        marginStart={2}
        onClick={onOpenFullScreen}
        title="Plein écran"
      >
        Plein écran
      </Button>
    </ButtonGroup>
  </Flex>
);

export default EditRecipeActionBar;
